import React from 'react';

export default function LandingFooter({ onShowTerms, onShowPrivacy }) {
  return (
    <footer className="dl-footer">
      <div className="dl-footer-word" aria-hidden="true">VROOM</div>
      <div className="dl-footer-top">
        <a className="dl-brand" href="#top"><img src="/assests/Logotyp.png" alt="" /><span>VROOM</span><i>.</i></a>
        <p>Zbudowane dla ludzi,<br />którzy żyją drogą.</p>
        <a href="mailto:kontakt@v-room.app">kontakt@v-room.app ↗</a>
      </div>
      <div className="dl-footer-bottom">
        <span>© 2026 VROOM.APP</span>
        <div><button type="button" onClick={onShowTerms}>Regulamin</button><button type="button" onClick={onShowPrivacy}>Polityka prywatności</button></div>
        <span>MADE IN POLAND <b>●</b></span>
      </div>
    </footer>
  );
}
